"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js");exports.default=function(r,o){return e.__awaiter(this,void 0,void 0,(function*(){const{error:e}=o.props;if(null==e)return;let t;t="function"==typeof e?yield e(r):e,"boolean"==typeof t?o.setState({error:t}):console.error('"Error" prop should be a boolean or a function that returns a boolean value.')}))};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/form-elements/cjs/functions/showError.js
// module id = 958
// module chunks = 0